export default __webpack_public_path__ + "static/span-management-5623cbb309124ead0645fd40b0c6cf2f.webp";